import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { selectdProject } from "../../features/projects/projectSlice";

const Project = ({ project }) => {
  const dispatch = useDispatch();
  const { id, projectName, colorClass } = project || {};
  const [isChecked, setIsChecked] = useState(true);

  const handleOnChange = (pid) => {
    setIsChecked(!isChecked);
    dispatch(selectdProject(pid));
  };
  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        className={colorClass}
        checked={isChecked}
        onChange={() => handleOnChange(id)}
      />
      <p className="label">{projectName}</p>
    </div>
  );
};

export default Project;
